(() => {
  function initRails(scope) {
    scope.querySelectorAll('.made-rail:not([data-made-rail-ready])').forEach((section) => {
      section.dataset.madeRailReady = 'true';
      const rail = section.querySelector('[data-made-rail]');
      if (rail) {
        rail.dataset.madeManualRail = 'true';
        const cards = [...rail.querySelectorAll(':scope > .made-card')];
        const batchSize = Math.max(Number.parseInt(rail.dataset.madeBatchSize || '20', 10) || 20, 1);
        const status = document.createElement('p');
        status.className = 'made-rail__status';
        status.dataset.madeRailStatus = 'true';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        section.append(status);

        cards.forEach((card, index) => {
          const initiallyVisible = index < batchSize;
          card.classList.toggle('is-made-batch-visible', initiallyVisible);
          card.setAttribute('aria-hidden', initiallyVisible ? 'false' : 'true');
          if (!initiallyVisible) card.setAttribute('inert', '');
        });
        rail.dataset.madeVisibleCount = String(Math.min(batchSize, cards.length));

        if (!matchMedia('(prefers-reduced-motion: reduce)').matches && cards.length > 4) {
          let timer;
          const play = () => { clearInterval(timer); timer = setInterval(() => rail.scrollBy({left: -Math.max(rail.clientWidth * .24, 190), behavior:'smooth'}), 9000); };
          const stop = () => clearInterval(timer);
          rail.addEventListener('pointerenter', stop); rail.addEventListener('pointerleave', play);
          rail.addEventListener('focusin', stop); rail.addEventListener('focusout', play);
          rail.addEventListener('touchstart', stop, {passive:true}); rail.addEventListener('touchend', play, {passive:true});
          play();
        }
      }
    });
    if (document.documentElement.dataset.madeRailDelegated === 'true') return;
    document.documentElement.dataset.madeRailDelegated = 'true';
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-made-scroll]');
      if (!button) return;
      const rail = button.closest('.made-rail')?.querySelector('[data-made-rail]');
      if (!rail) return;
      const cards = [...rail.querySelectorAll(':scope > .made-card')];
      const batchSize = Math.max(Number.parseInt(rail.dataset.madeBatchSize || '20', 10) || 20, 1);
      const visibleCount = Math.max(Number.parseInt(rail.dataset.madeVisibleCount || String(Math.min(batchSize, cards.length)), 10), 0);

      if (button.dataset.madeScroll === 'next' && visibleCount < cards.length) {
        const nextVisibleCount = Math.min(visibleCount + batchSize, cards.length);
        const newCards = cards.slice(visibleCount, nextVisibleCount);
        newCards.forEach((card, index) => {
          card.classList.add('is-made-batch-visible', 'is-made-batch-entering');
          card.style.setProperty('--made-batch-order', String(index));
          card.setAttribute('aria-hidden', 'false');
          card.removeAttribute('inert');
        });
        rail.dataset.madeVisibleCount = String(nextVisibleCount);
        const status = button.closest('.made-rail')?.querySelector('[data-made-rail-status]');
        if (status) status.textContent = `تم تحميل ${newCards.length} منتجًا إضافيًا. المعروض الآن ${nextVisibleCount} منتجًا.`;
        window.setTimeout(() => {
          newCards.forEach((card) => card.classList.remove('is-made-batch-entering'));
        }, 1100);
      }

      const amount = Math.max(rail.clientWidth * 0.82, 280);
      rail.scrollBy({
        left: button.dataset.madeScroll === 'next' ? -amount : amount,
        behavior: 'smooth'
      });
    });
  }

  function initHero(scope) {
    scope.querySelectorAll('[data-made-hero-slider]:not([data-made-hero-ready])').forEach((root) => {
      root.dataset.madeHeroReady = 'true';
      const slides = [...root.querySelectorAll('[data-made-hero-slide]')];
      const dots = [...root.querySelectorAll('[data-made-hero-dot]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let timer;
      let paused = false;

      const show = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.tabIndex = active ? 0 : -1;
        });
        dots.forEach((dot, index) => dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false'));
      };
      const stop = () => window.clearInterval(timer);
      const play = () => {
        stop();
        if (!reducedMotion.matches && !paused && !document.hidden && slides.length > 1) {
          timer = window.setInterval(() => show(activeIndex + 1), 5600);
        }
      };

      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); play(); }));
      root.addEventListener('pointerenter', () => { paused = true; stop(); });
      root.addEventListener('pointerleave', () => { paused = false; play(); });
      root.addEventListener('focusin', () => { paused = true; stop(); });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { paused = false; play(); } });
      document.addEventListener('visibilitychange', play);
      reducedMotion.addEventListener?.('change', play);
      show(0);
      play();
    });
  }

  function init(scope = document) {
    initHero(scope);
    initRails(scope);
  }
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
